import Joi from 'joi';

import { objectId } from '@/shared/validations/custom.validation';

export const getFast2sms = {
  query: Joi.object().keys({
    name: Joi.string(),
    fast2sms: Joi.string(),
    sortBy: Joi.string(),
    search: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    companyId: Joi.string(),
    includeTimeStamps: Joi.boolean(),
    project: Joi.string(),
    status: Joi.string(),
  }),
};

export const updateTemplate = {
  params: Joi.object().keys({
    templateId: Joi.string().custom(objectId),
  }),
};

export const addFast2smsCreds = {
  body: Joi.object().keys({
    accessToken: Joi.string(),
    senderId: Joi.string(),
  }),
};

export const bulkUploadTemplate = {
  body: Joi.object().keys({
    templates: Joi.array(),
  }),
};
